import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import Slide01 from '@/ui-assets/images/slide01.png';
import Slide02 from '@/ui-assets/images/slide02.png';
import Slide03 from '@/ui-assets/images/slide03.png';
import Slide04 from '@/ui-assets/images/slide04.png';
import Slide05 from '@/ui-assets/images/slide05.png';
import MobileSlideBg from '@/ui-assets/images/mobile-slide-bg.webp';

import styles from './index.module.scss';
import { useMemo } from 'react';

const IntroSwiper = () => {
  const slides = useMemo(() => [
    {
      key: 'slide01',
      image: Slide01,
    },
    {
      key: 'slide02',
      image: Slide02,
    },
    {
      key: 'slide03',
      image: Slide03,
    },
    {
      key: 'slide04',
      image: Slide04,
    },
    {
      key: 'slide05',
      image: Slide05,
    },
  ], []);

  // Shuffle slides on component mount
  const shuffledSlides = useMemo(() => [...slides].sort(() => Math.random() - 0.5), [slides]);

  return (
    <div className={styles.swiperContainer}>
      <Swiper
        loop
        modules={[Pagination, Autoplay]}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        {shuffledSlides.map((slide) => (
          <SwiperSlide key={slide.key}>
            <div className={styles.slide}>
              <img src={slide.image} alt="" className={styles.image} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <img src={MobileSlideBg} className={styles.slideBg} alt="" />
    </div>
  );
};

export default IntroSwiper;
